/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  GET_PAGE_CONTENT: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.boilerplate.InvitationOverview.getPageContent',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'GET_PAGE_CONTENT' },
      },
    },
    GET_PAGE_CONTENT: {
      invoke: {
        id: 'getPageContent',
        src: 'getPageContent',
        onDone: {
          target: 'RENDER_PAGE',
          actions: ['successAction'],
        },
        onError: {
          target: 'RENDER_PAGE_ERROR',
          actions: ['failureAction'],
        },
      },
    },
    RENDER_PAGE: {
      on: {
        TRIGGER_REFRESH: {
          target: 'GET_PAGE_CONTENT',
        },
      },
    },
    RENDER_PAGE_ERROR: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
